<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click.stop="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span /></td>
    <td class="no_padding">
      <input
        type="checkbox"
        :id="entity.id"
        :value="entity.id"
        @click.stop
        @change="onChange"
        :checked="isChecked"
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Kód' | translate">
        <a>{{ entity.code }}</a>
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteProvider">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: 'AdvertisingProviderRow',
  mixins: [rowActions],
  props: {
    entity: Object,
    selectedProviders: Array,
  },
  data() {
    return {
      moduleName: 'advertisingProviders',
    }
  },
    methods: {
    goToDetail(e, id) {
      this.$router.push({name: 'advertisingProviderDetail', params: {id: id}})
    },
    emitDeleteProvider() {
      this.$emit('deleteProvider', this.entity.id)
    },
    onChange: function (e) {
      this.$emit('input', e)
    },
  },
  computed: {
    isChecked() {
      return this.selectedProviders.indexOf(String(this.entity.id)) > -1
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/AdvertisingProviderRow.vue